import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import {
  TypeItemOnMachineAddBody,
  TypeItemOnMachineUpdateBody,
} from 'src/app/api/backend/dto/scheduler-item-on-machine.dto';
import { SchedulerItemOnMachine } from 'src/app/common/scheduler/models/item-on-machine';
import { SchedulerDragDropApiAbstract } from '../../../../common/scheduler/api/drag-drop';

@Injectable({
  providedIn: 'root',
})
export class PackingBoxSalesOrderRankDragDropApiService extends SchedulerDragDropApiAbstract {
  addItem(body: TypeItemOnMachineAddBody): Observable<SchedulerItemOnMachine> {
    throw new Error('Method not implemented.');
  }
  updateItem(
    body: TypeItemOnMachineUpdateBody
  ): Observable<SchedulerItemOnMachine> {
    throw new Error('Method not implemented.');
  }
  removeItem(itemId: number, machineId: number): Observable<any> {
    return of(undefined);
  }
  updateRank(itemId: number, rank: string): Observable<any> {
    return of(undefined);
  }
}
